import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { SurveyUpsertPage } from '../components/SurveyUpsertPage';
import { getPageLinks as getUpdatePageLinks } from '../utils/getPageLinks';
import { messages } from '../messages';
import { useGetContainerProps } from '../hooks/useGetContainerProps';

export const SurveyUpdatePageContainer = () => {
  const { id = '' } = useParams<{ id: string }>();

  const isUserPermittedToEditSurvey = useIsUserPermittedTo(Feature.SURVEY_EDIT);

  const containerProps = useMemo(() => {
    const updatePageLabel = isUserPermittedToEditSurvey ? 'Update Survey' : 'Survey Configurations';
    return {
      getBreadcrumbLinks: () => getUpdatePageLinks(updatePageLabel),
      surveyId: id,
    };
  }, [id, isUserPermittedToEditSurvey]);

  const {
    layoutProps,
    configureFormProps,
    targetFormProps,
    scheduleFormProps,
    dialogProps,
    breadcrumbLinks,
  } = useGetContainerProps(containerProps);

  return (
    <SurveyUpsertPage
      layoutProps={layoutProps}
      dialogProps={dialogProps}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      configureFormProps={configureFormProps}
      targetFormProps={targetFormProps}
      scheduleFormProps={scheduleFormProps}
      breadcrumbLinks={breadcrumbLinks}
    />
  );
};
